// extracted by mini-css-extract-plugin
export default {"inputLabelContainer":"InputLabel-module__inputLabelContainer-oKdM","labelText":"InputLabel-module__labelText-xgK4"};